<template>
<div class="grid grid-cols-1 md:grid-cols-2">
    <section class="border border-gray-800 p-3">

        <label>Add panorama file</label>
        <RecommendedAspectRatio uploadBoxType="panorama-image" />

        <div v-if="!form.feature_files.panorama_files.languages[form.current_language].loaded_file_path" class="upload-box">
            <span>
                <i class="icon-upload mr-2"></i><a href="##" @click.prevent="changeUploadBoxState(panorama_file_state)">Upload from media library</a>
            </span>
            <span>{{ panoramaFileName() }}</span>
        </div>

        <div v-if="form.feature_files.panorama_files.languages[form.current_language].loaded_file_path" class="upload-box">
            <div class="">
                <img :src="form.feature_files.panorama_files.languages[form.current_language].loaded_file_path" class="logo-img">
            </div>
        </div>

        <div v-if="form.with_audio" class="mt-5">
            <h5 class="text-lg font-bold text-white">Audio File</h5>
            <div class="upload-box-sm">
                <span>
                    <i class="icon-upload mr-2"></i><a href="##" @click.prevent="changeUploadBoxState('panorama_feature_audio')">Upload from media library</a>
                </span>
                <span>{{ audioFileName() }}</span>
            </div>
        </div>

    </section>

    <section class="border border-gray-800 p-3">

        <div class="radio-box">
            <h5 class="text-lg font-bold text-white">Select feature type</h5>
            <span class="block" :class="{'opacity-20 pointer-events-none':selectFeatureTypeEnabled}">
                <input type="radio" id="panorama_image" name="file_type" value="panorama_image"
                       @input="$emit('update:currentFileType', $event.target.value)" checked="checked">
                <label for="panorama_image">Panorama image</label>
            </span>
            <span class="block" :class="{'opacity-20 pointer-events-none':selectFeatureTypeEnabled}">
                <input type="radio" id="panorama_video" name="file_type" value="panorama_video"
                @input="$emit('update:currentFileType', $event.target.value)">
                <label for="panorama_video">Panorama video</label>
            </span>
        </div>

        <div class="radio-box">
            <h5 class="text-lg font-bold text-white">With Audio ?</h5>
            <span class="block">
                <input type="radio" name="with_audio"
                @input="$emit('update:withAudio', true)" id="yes">
                <label for="yes">Yes</label>
            </span>

            <span class="block">
                <input type="radio" name="with_audio"
                @input="$emit('update:withAudio', false)" id="no" checked="checked">
                <label for="no">No</label>
            </span>
        </div>

        <div v-if="form.with_audio" class="mt-5 radio-box">
            <h5 class="text-lg font-bold text-white">Loop</h5>
            <span class="block">
                <input type="radio" name="audio_loop" @input="$emit('update:audioLoop', true)"
                id="loop_yes">
                <label for="loop_yes">Yes</label>
            </span>

            <span class="block">
                <input type="radio" name="audio_loop" @input="$emit('update:audioLoop', false)"
                id="loop_no" checked="checked">
                <label for="loop_no">No</label>
            </span>
        </div>

        <div v-if="form.with_audio" class="mt-5">
            <h5 class="text-lg font-bold text-white">Volume</h5>
            <div class="range-slider-wrapper">
                <input type="range" min="1"
                @input="$emit('update:audioVolume', parseInt($event.target.value))"
                max="100">
            </div>
        </div>

    </section>
</div>
<section class="border border-gray-800 p-3">
    <div class="block text-center">
        <button v-if="!form.processing" class="btn btn-gradient" @click="saveFile"><i class="save"></i></button>
        <button v-else class="btn btn-gradient"><Spinner/></button>
    </div>
</section>

</template>

<script>
import Spinner from '@/UI/Spinner';
import RecommendedAspectRatio from '@/Pages/Media/RecommendedAspectRatio';

export default {
    components: {
        Spinner,
        RecommendedAspectRatio,
    },
    props: {
      form: Object,
      saveFile: Function,
      currentFileType: String,
      withAudio: Boolean,
      audioLoop: Boolean,
      audioVolume: Number,
      changeUploadBoxState: Function,
      langDisabled: Function
    },
    data(){
        return{
            panorama_file_state: 'panorama_file_image',
            selectFeatureTypeEnabled: true
        }
    },
    updated(){
        this.updatePanoramaFileState();
        this.toggleFeatureTypeSelect();
    },
    emits: ['update:currentFileType', 'update:withAudio', 'update:audioLoop', 'update:audioVolume',
            'update:audioFile'],
    methods: {
        errors(){
            return this.$page.props.errors;
        },
        panoramaFileName(){
            return this.form.feature_files.panorama_files.languages[this.form.current_language].file &&
            this.form.feature_files.panorama_files.languages[this.form.current_language].file.name;
        },
        audioFileName(){
            if(this.form.feature_files.audio_files.languages[this.form.current_language].from_media_library_id)
            {
                return this.form.feature_files.audio_files.languages[this.form.current_language].loaded_file_path
            } else {
                return this.form.feature_files.audio_files.languages[this.form.current_language].file &&
                this.form.feature_files.audio_files.languages[this.form.current_language].file.name;
            }
        },
        updatePanoramaFileState(){
            if(!this.form.current_filetype)
            {
                return
            }
            if(this.form.current_filetype == 'panorama_image')
            {
                this.panorama_file_state = 'panorama_file_image';
            }
            if(this.form.current_filetype == 'panorama_video')
            {
                this.panorama_file_state = 'panorama_file_video';
            }
        },
        toggleFeatureTypeSelect(){
            const non_fallback_lang = this.$page.props.tour.data.languages
            .filter(el => el != this.$page.props.tour.data.fallback_language)[0];

            if(this.langDisabled(non_fallback_lang) == false) {
                //langDisabled false, means lang Enabled
                //if non fallback language is enabled we enable select for feature type
                this.selectFeatureTypeEnabled = true;
            } else {
                this.selectFeatureTypeEnabled = false;
            }
        }
    }
}
</script>
